import {
    AxisTimeConfigItem,
    ChartConfigItem,
    DetailConfigItem,
    GridConfigItem,
    MirroredValueConfigItem,
    SlicerConfigItem,
    TooltipConfigItem,
    ValueConfigItem,
} from './config-item';

// TODO: move to lib-visualizations
export class VizConfigs {
    values: ValueConfigItem[];
    slicers: SlicerConfigItem[];
    tooltips: TooltipConfigItem[];
    axisTimes?: AxisTimeConfigItem[];
    details?: DetailConfigItem[];
    mirroredValues?: MirroredValueConfigItem[];

    constructor(init?: Partial<VizConfigs>) {
        this.values = init?.values ?? [];
        this.slicers = init?.slicers ?? [];
        this.tooltips = init?.tooltips ?? [];
        this.axisTimes = init?.axisTimes;
        this.details = init?.details;
        this.mirroredValues = init?.mirroredValues;
    }
}

export interface ChartConfigs {
    values: ChartConfigItem[];
    slicers: SlicerConfigItem[];
    tooltips: TooltipConfigItem[];
    axisTimes?: AxisTimeConfigItem[];
    details?: DetailConfigItem[];
    mirroredValues?: MirroredValueConfigItem[];
}

export interface GridConfigs {
    values: GridConfigItem[];
}
